import { FC } from "react";
import {
  storyAccordionClasses,
  StyledStoryAccordion,
} from "./StyledStoryAccordion";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import challenge from "./images/challenge.png";
import intervention from "./images/intervention.png";
import outcomes from "./images/outcomes.png";

import { IStory } from "../../interfaces/IStory";

interface IStoryAccordion {
  accordionSections: string[];
  story: IStory;
}

export const StoryAccordion: FC<IStoryAccordion> = ({
  accordionSections,
  story,
}) => {
  const displayOutcomes = (outcome: {
    type: "bullets" | "text";
    bullets?: string[];
    text?: string;
    header?: string;
    body?: string;
  }) => {
    if (outcome.type === "text") {
      return (
      <Typography
        component="div" // Add the component prop with the value "div"
        sx={{
          fontSize: "18px",
          lineHeight: "26px",
          color: "#011E3F",
          fontFamily: "Inter",
          fontWeight: "100",
          padding: "0 20px 20px 20px",
        }}
        dangerouslySetInnerHTML={{ __html: outcome.text ?? "" }}
      ></Typography>
      )
    } else {
      return (
          <>
          {outcome.header && (<Typography
                    component="div"
                    key={outcome.header}
                    sx={{
                      textAlign: "left",
                      fontSize: "18px",
                      lineHeight: "26px",
                      color: "#011E3F",
                      fontFamily: "Inter",
                      fontWeight: "100",
                      marginBottom: "20px",
                    }}
                >
                  {outcome.header}
                </Typography>
          )}

        {outcome.body && (
          <Typography
            component="div"
            sx={{
              fontSize: "18px", 
              lineHeight: "26px",
              color: "#011E3F",
              fontFamily: "Inter",
              fontWeight: "100",
              padding: "0 20px 20px 20px"
            }}
            dangerouslySetInnerHTML={{ __html: outcome.body }}
          />
        )}

        <ul style={{ margin: 0 }}>
          {outcome.bullets!.map((source: string, index: number) => {
            return (
              <Typography
                component="li"
                key={index}
                sx={{
                  textAlign: "left",
                  fontSize: "18px",
                  lineHeight: "26px",
                  color: "#011E3F",
                  fontFamily: "Inter",
                  fontWeight: "100",
                  marginBottom: "20px",
                }}
              >
                <span dangerouslySetInnerHTML={{ __html: source }} />
              </Typography>
            );
          })}
        </ul>
          </>
      );
    }
  };

  return (
    <StyledStoryAccordion className={storyAccordionClasses.root}>
      {accordionSections.map((section, index) => (
        <Accordion
          key={section}
          defaultExpanded={index === 0}
          className={storyAccordionClasses.accordion}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id={`panel1a-header-${section}`}
            className={storyAccordionClasses.accordionSummary}
          >
            <Typography>{section}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {index === 0 && (
              <div>
                <img
                  src={challenge}
                  alt=""
                  style={{ float: "left", padding: "45px 100px" }}
                />
                <Typography
                  sx={{
                    fontSize: "18px",
                    lineHeight: "26px",
                    color: "#011E3F",
                    fontFamily: "Inter",
                    fontWeight: "100",
                    padding: "0 20px 20px 20px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: story.sexualAndReproductiveHealthChallenge,
                  }}
                ></Typography>
              </div>
            )}
            {index === 1 && (
              <div>
                <img
                  src={intervention}
                  alt=""
                  style={{ float: "left", padding: "45px 100px" }}
                />
                <Typography
                  sx={{
                    fontSize: "18px",
                    lineHeight: "26px",
                    color: "#011E3F",
                    fontFamily: "Inter",
                    fontWeight: "100",
                    padding: "0 20px 20px 20px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      story.sexualAndReproductiveHealthUniversalHealthCoverageIntervention,
                  }}
                ></Typography>

                {story.sexualAndReproductiveHealthUniversalHealthCoverageIntervention && 
                 story.sexualAndReproductiveHealthUniversalHealthCoverageInterventionBullets && (
                  <div style={{ clear: "both" }}></div>
                )}

                {story.sexualAndReproductiveHealthUniversalHealthCoverageInterventionBullets && (
                  <ul style={{ padding: "0 20px 20px 40px" }}>
                    {story.sexualAndReproductiveHealthUniversalHealthCoverageInterventionBullets.map((bullet, i) => (
                      <li
                        key={i}
                        style={{
                          fontSize: "18px",
                          lineHeight: "26px",
                          color: "#011E3F",
                          fontFamily: "Inter",
                          fontWeight: "100",
                          marginBottom: "10px"
                        }}
                        dangerouslySetInnerHTML={{
                          __html: bullet
                        }}
                      >
                      </li>
                    ))}
                  </ul>
                )}
                {/*<img*/}
                {/*  src={accordionImg}*/}
                {/*  alt=""*/}
                {/*  style={{ width: "100%", padding: "0 20px" }}*/}
                {/*/>*/}
              </div>
            )}
            {index === 2 && (
              <Grid container>
                {story.sexualAndReproductiveHealthUniversalHealthCoverageOutcomes && (
                  <Typography
                    sx={{
                      fontSize: "18px",
                      lineHeight: "26px",
                      color: "#011E3F",
                      fontFamily: "Inter",
                      fontWeight: "100",
                      padding: "0 20px 20px 20px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        story.sexualAndReproductiveHealthUniversalHealthCoverageOutcomes,
                    }}
                    >
                  </Typography>
                )}
                
                {story.outcomes && story.outcomes.map((outcome, outcomeIndex) => {
                  if (outcome.type === "text") {
                    return (
                      <Typography
                        key={outcomeIndex}
                        component="div"
                        sx={{
                          fontSize: "18px",
                          lineHeight: "26px",
                          color: "#011E3F",
                          fontFamily: "Inter",
                          fontWeight: "100",
                          padding: "0 20px 20px 20px",
                        }}
                        dangerouslySetInnerHTML={{ __html: outcome.value }}
                      />
                    );
                  } else if (outcome.type === "image") {
                    return (
                      <img
                        key={outcomeIndex}
                        src={outcome.value}
                        alt=""
                        style={{ 
                          maxWidth: "100%", 
                          padding: "0 20px 20px 20px",
                          margin: "30px auto",
                          display: "block"
                        }}
                      />
                    );
                  } else if (outcome.type === "heading") {
                    return (
                      <Typography
                        key={outcomeIndex}
                        component="h3"
                        sx={{
                          fontSize: "20px",
                          lineHeight: "28px",
                          color: "#011E3F",
                          fontFamily: "Inter",
                          fontWeight: "bold",
                          padding: "20px 20px 10px 20px",
                          margin: 0,
                        }}
                        dangerouslySetInnerHTML={{ __html: outcome.value }}
                      />
                    );
                  }
                  return null;
                })}

                {story.success && (
                  <Grid container>
                    <Typography sx={{ fontWeight: "bold", margin: "10px 0" }}>
                      Success
                    </Typography>
                    <div>
                      <img
                        src={outcomes}
                        alt=""
                        style={{ float: "left", padding: "45px 100px" }}
                      />

                      {story.success.body && (
                        <Typography
                          component="div"
                          sx={{
                            fontSize: "18px",
                            lineHeight: "26px", 
                            color: "#011E3F",
                            fontFamily: "Inter",
                            fontWeight: "100",
                            padding: "0 20px 20px 20px",
                          }}
                          dangerouslySetInnerHTML={{ __html: story.success.body }}
                          ></Typography>
                        )}

                        {story.success.body && story.success.bullets && (
                          <div style={{ clear: "both" }}></div>
                        )}

                      {displayOutcomes(story.success)}

                      {story.successArray && story.successArray.map((successItem, successIndex) => {
                        if (successItem.type === "text") {
                          return (
                            <Typography
                              key={successIndex}
                              component="div"
                              sx={{
                                fontSize: "18px",
                                lineHeight: "26px",
                                color: "#011E3F",
                                fontFamily: "Inter",
                                fontWeight: "100",
                                padding: "0 20px 20px 20px",
                              }}
                              dangerouslySetInnerHTML={{ __html: successItem.value }}
                            />
                          );
                        } else if (successItem.type === "image") {
                          return (
                            <img
                              key={successIndex}
                              src={successItem.value}
                              alt=""
                              style={{ 
                                maxWidth: "100%", 
                                padding: "0 20px 20px 20px",
                                margin: "30px auto",
                                display: "block"
                              }}
                            />
                          );
                        } else if (successItem.type === "heading") {
                          return (
                            <Typography
                              key={successIndex}
                              component="h3"
                              sx={{
                                fontSize: "20px",
                                lineHeight: "28px",
                                color: "#011E3F",
                                fontFamily: "Inter",
                                fontWeight: "bold",
                                padding: "20px 20px 10px 20px",
                                margin: 0,
                              }}
                              dangerouslySetInnerHTML={{ __html: successItem.value }}
                            />
                          );
                        }
                        return null;
                      })}
                    </div>
                  </Grid>
                )}
                
                {story.challenges && (
                  <Grid container>
                    <Typography sx={{ fontWeight: "bold", margin: "10px 0" }}>
                      Challenges
                    </Typography>
                    <div>
                      <img
                        src={outcomes}
                        alt=""
                        style={{ float: "left", padding: "45px 100px" }}
                      />
                      {displayOutcomes(story.challenges)}
                    </div>
                  </Grid>
                )}
              </Grid>
            )}
            {index === 3 && (
                <Grid container>
                  {story.lessons && (
                      <Grid container>
                        {displayOutcomes(story.lessons)}
                      </Grid>
                  )}
                </Grid>
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </StyledStoryAccordion>
  );
};
